export function getAll() {
  var items = [
    {
      value: 0,
      name: "Closing",
      text: "已關帳，系統將於 00:00 跨日執行成本月結",
    },
    {
      value: 1,
      name: "Completed",
      text: "已完成月結，本月可重新開帳",
    },
    {
      value: 2,
      name: "Opening",
      text: "已開帳，修改完單據後請重新月結關帳",
    },
  ];
  return items;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
